import { Component, OnInit } from '@angular/core';
import { WebpagesService } from '../../../@core/services/webpages.service';

@Component({
  selector: 'webpage',
  templateUrl: './webpage.component.html',
  styleUrls: ['./webpage.component.scss']
})
export class WebpageComponent implements OnInit {

  constructor(public _webpagesService: WebpagesService,) { }

  public displayedColumns: string[] = ['Priority', 'Title', 'ShortDescription'];

  ngOnInit() {
    this._webpagesService.initialiseWebPages(0, 1);
  }

}
